import React, { useEffect, useRef } from 'react';
import Link from '@/components/atoms/link';
import { CheckoutProps } from './types';
import CheckoutProvider from './provider';
import CheckoutHeader from './components/checkout-header';
import CheckoutBackToCart from './components/checkout-back-to-cart.tsx';
import Button from '@/components/atoms/button';
import CheckoutBody from './components/checkout-body';
import Spinner from '../spinner';
import { ChevronLeftIcon } from '@heroicons/react/24/solid';

const Checkout = ({
  details,
  setDetails,
  sum,
  addresses,
  initialData = {},
  shippingMethods = [],
  loading,
  handleReview,
  error,
  setError,
  validateForm,
  setValidateForm
}: CheckoutProps) => {
  const checkoutEl = useRef<HTMLDivElement>(null);

  const hash = typeof window !== 'undefined' ? window.location.hash : "";

  useEffect(() => {
    if (loading || !checkoutEl.current || !hash) {
      return;
    }
    const element = checkoutEl.current.querySelector(hash);
    const inputEl = element?.querySelector('input,textarea') as HTMLElement;
    element?.scrollIntoView({ block: 'center' });
    if (inputEl) {
      inputEl.focus();
    }
  }, [hash, loading]);
  return (
    <CheckoutProvider addresses={addresses}>
      {loading && <Spinner />}
      {loading && <div className="overlay fixed left-0 top-0 z-[1002] h-full w-full bg-gray-800 opacity-75"></div>}
      <div ref={checkoutEl} className="min-h-screen bg-neutral-200 relative">
        <div className="flex flex-col sm:pt-0 sm:pb-0 pt-5 pb-2.5 sm:py-4 md:py-6 lg:items-start bg-[#F3EDE9] lg:pt-7 lg:pb-4 lg:py-0 px-4 lg:px-12">
          <CheckoutHeader />
          <div className="w-fill-available sm:!bg-white bg-neutral-200 lg:ml-16 lg:mr-16 py-[6px] sm:py-4 md:py-6 lg:bg-transparent lg:py-0 lg:pt-[26px] lg:px-[29px] lg:pb-[68px] sm:mt-4 mb-4">
            <CheckoutBackToCart />
            <div className="sm:px-10 md:px-[5.2rem]">
              <CheckoutBody validateForm={validateForm} setError={setError} error={error} shippingMethods={shippingMethods} details={details} setDetails={setDetails} addresses={addresses} initialData={initialData} setValidateForm={setValidateForm} />
              <div className="flex md:flex-row flex-col gap-2 justify-between items-center">
                <div className="md:w-fit w-full">
                  <Link link={"/"}>
                    <Button
                      Icon={ChevronLeftIcon}
                      iconClassName='w-[32px] h-[32px]'
                      iconPosition="left"
                      variant="secondary"
                      className='!py-4 !px-4 !text-18 h-[56px] md:w-fit w-full justify-center !bg-white !cursor-pointer'

                    >Continue Shopping</Button>
                  </Link>
                </div>
                <div className="md:w-fit w-full">
                  <Button onClick={handleReview} className='!py-4 cursor-pointer !px-10 !text-18 md:w-[223px] !bg-black h-[56px] w-full' variant='primary'>Review</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckoutProvider>
  );
};

export default Checkout;
